/**
 * Pathless layout for the public site: every page under routes/_site/
 * renders inside SiteLayout (skip link, SiteHeader, <main>, SiteFooter).
 * Split into its own chunk and free of AppShell, so a visitor never loads
 * the signed-in frame. The layout needs no session: a page that must send a
 * signed-in chef elsewhere (the home page) does that in its own beforeLoad.
 *
 * A page under it that cannot load (the API down mid-deploy, a lost
 * connection, a page's code replaced by a release) shows the designed error
 * page (features/public/PublicError), never the router's own. The pages
 * have no error component of their own, so the error comes up to this one.
 */
import { createFileRoute } from '@tanstack/react-router';
import { PublicError } from '@/features/public/PublicError';
import { SiteLayout } from '@/features/site/SiteLayout';

export const Route = createFileRoute('/_site')({
  component: SiteLayout,
  errorComponent: PublicError,
});
